import deserializeParagraph from './deserialize';
import renderParagraph from './render';

const ParagraphPlugin = options => ({
  renderElement: renderParagraph(options),
  deserialize: deserializeParagraph(options),
});

export default ParagraphPlugin;
